import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Stack,
  TextField,
  Paper,
  Button,
  Grid,
  Snackbar,InputAdornment,
  Alert,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

import { Delete } from "@mui/icons-material";
import AnimatedPage from "../animatedPage/AnimatedPage";
import Hoc from "../HOC/Hoc";
import TopHeading from "../../utils/TopHeading/TopHeading";
import CustomDataTable from "../../views/CustomTable/CustomDataTable";
import { getActivepanels } from "../managePanel/managePanel.api";
import CustomTooltip from "../../../src/utils/CustomTooltip";
import { Link } from "react-router-dom";

import {
  updatePriority,
  getPrioritySurvey,
} from "../../components/Priority Survey/PrioritySurvey.api";

const PrioritySurvey = () => {
  const [selectedPanel, setSelectedPanel] = useState({});
  const [prioritySurveys, setPrioritySurveys] = useState([]);
  const [surveyId, setSurveyId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [columns, setColumns] = useState([]);
  const [pending, setPending] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [refresh, setRefresh] = useState(false);

  const adminId = useSelector((state) => state.auth.userData?.tenantId);

  useEffect(() => {
    getActivepanels(adminId)
      .then((res) => {
        if (res?.status === 200) {
          setSelectedPanel(res.data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching panels:", err));
  }, [adminId]);

  const handleSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleDelete = (clientSurveyId) => {
    updatePriority(clientSurveyId, 0).then((res) => {
      if (res?.data.success) {
        handleSnackbar("Survey Removed Successfully!", "error");
        setRefresh((prev) => !prev);
      } else {
        handleSnackbar(res?.data.message || "Something Went Wrong", "error");
      }
    });
  };

  useEffect(() => {
    setColumns([
      {
        name: (
          <>
            <CustomTooltip title={"Client Survey ID"} childrenText={"CSID"} />
          </>
        ),
        selector: (row) => row.clientSurveyId,
        sortable: true,
        width: "120px",
        cell: (row) => (
          <Stack direction={"row"}>
            <Link to={`/admin/edit-survey/${row.surveyId}`} target="_blank">
              {row.clientSurveyId}
            </Link>
          </Stack>
        ),
      },
      {
        name: "Country",
        selector: (row) => row.countryCode,
        sortable: true,
        width: "100px",
      },
      {
        name: (
          <>
            <CustomTooltip title={"Sample Count"} childrenText={"SCount"} />
          </>
        ),
        selector: (row) => row.sampleCount,
        sortable: true,
        width: "100px",
      },
      {
        name: "Client",
        selector: (row) => row.clientName || "--",
        sortable: true,
        width: "120px",
      },
      {
        name: "CPI",
        selector: (row) => row.CPI || 0,
        sortable: true,
        width: "90px",
      },
      {
        name: "Starts",
        selector: (row) => row.starts,
        sortable: true,
        width: "90px",
      },
      {
        name: (
          <>
            <CustomTooltip title={"Complete"} childrenText={"COMP"} />
          </>
        ),
        selector: (row) => row.completes,
        sortable: true,
        width: "90px",
      },
      {
        name: "Revenue",
        selector: (row) => row.revenue || 0,
        sortable: true,
        width: "110px",
      },
      {
        name: (
          <>
            <CustomTooltip title={"Last Complete"} childrenText={"LCOMP"} />
          </>
        ),
        selector: (row) =>
          row.lastComplete && row.lastComplete !== "0"
            ? row.lastComplete
            : "--",
        sortable: true,
        width: "110px",
      },
      // {
      //   name: "Status",
      //   selector: (row) => (
      //     <>
      //       {row.surveyStatus === "live" ? (
      //         <div className="liveSurveyBtn">{row.surveyStatus}</div>
      //       ) : (
      //         <div className="closeSurveyBtn">{row.surveyStatus}</div>
      //       )}
      //     </>
      //   ),
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "Action",
        sortable: false,
        cell: (row) => (
          <Delete
            style={{ cursor: "pointer" }}
            onClick={() => handleDelete(row.clientSurveyId)}
          />
        ),
        width: "90px",
      },
    ]);

    setPending(false);
  }, []);

  useEffect(() => {
    if (!selectedPanel?.panelId) return;
    setPending(true);
    getPrioritySurvey(selectedPanel.panelId)
      .then((res) => {
        const surveys = res.data.success ? res.data.data : [];
        setPrioritySurveys(surveys);
      })
      .catch((err) => console.error("Error fetching surveys:", err))
      .finally(() => setPending(false));
  }, [selectedPanel, refresh]);

  const handleSurveyChange = (e) => setSurveyId(e.target.value);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleSubmit = () => {
    if (!surveyId) {
      handleSnackbar("Survey ID is required!", "error");
      return;
    }
    updatePriority(surveyId, 1).then((res) => {
      if (res?.data.success) {
        handleSnackbar("Survey Added Successfully!", "success");
        setRefresh((prev) => !prev);
        setSurveyId("");
      } else {
        handleSnackbar(res?.data.message || "Something Went Wrong", "error");
      }
    });
  };

  const filteredSurveys = prioritySurveys.filter((survey) =>
    survey.clientSurveyId
      ?.toString()
      ?.toLowerCase()
      ?.includes(searchTerm.toLowerCase())
  );
  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>

      <AnimatedPage>
        <TopHeading showButton={false} heading="Priority Survey" />
        <Paper sx={{ px: 2, py: 4, mx: 2, mb: 1 }} elevation={2}>
          <Stack spacing={3} alignItems="center">
            <Grid
              sx={{ px: 2, py: 1, mx: 2 }}
              container
              spacing={3}
              alignItems="center"
              justifyContent="space-between"
              className="prioritySurveyForm"
            >
              <Grid container alignItems="center" xs={12} sm={9} md={9}>
                <Grid sx={{ mx: 1 }}>
                  <TextField
                    type="text"
                    value={surveyId}
                    fullWidth
                    size="small" 
                    label="Client Survey ID"
                    onChange={handleSurveyChange}
                    variant="outlined"
                  />
                </Grid>

                <Grid sx={{ mx: 1 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>

              <Grid xs={12} sm={3} md={3}>
                <TextField
                  type="search"
                  value={searchTerm}
                  fullWidth 
                  size="small" 
                  label="Client Survey ID"
                  onChange={handleSearchChange}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Stack>
        </Paper>
        <Stack spacing={2} sx={{ mx: 4, my: 2 }}>
          <div className="data-table prioritySurveyTable">
            <CustomDataTable
              columns={columns}
              data={filteredSurveys}
              pagination
              progressPending={pending}
              highlightOnHover
            />
          </div>
        </Stack>
      </AnimatedPage>
    </>
  );
};

export const PrioritySurveyPage = Hoc(PrioritySurvey, { name: "" });
